import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { Col, Container, Row } from 'react-bootstrap';
import Review from '../../../components/stateful/Review';

const propTypes = {
  googlePlaceId: PropTypes.string,
  reviews: PropTypes.arrayOf(PropTypes.object).isRequired,
};

const defaultProps = {
  googlePlaceId: null,
};

const renderPlaceholder = () => (
  <Col xs={12}>
    Please set the Google Place ID.
  </Col>
);

const renderReview = (review, index) => (
  <Col sm={4} key={`review-${index}`}>
    <Review
      body={review.body}
      rating={review.rating}
      author={get(review, 'author.name')}
      date={review.time}
      googleReview
    />
  </Col>
);

const renderReviews = (reviews) => {
  if (reviews.length === 0) {
    return (
      <Col xs={12}>
        No reviews.
      </Col>
    );
  }

  return reviews.slice(0, 3).map(renderReview);
};

const Reviews = ({ googlePlaceId, reviews }) => (
  <div>
    <Container>
      <Row>
        {googlePlaceId ? renderReviews(reviews) : renderPlaceholder()}
      </Row>
    </Container>
  </div>
);

Reviews.propTypes = propTypes;
Reviews.defaultProps = defaultProps;

export default Reviews;
